module.exports = __webpack_public_path__ + "images/152_1024.jpg";